import type { Layout } from 'react-grid-layout';
import { BlockIdContext, BlockWidthContextProvider } from '../studio-blocks';
import React, { forwardRef } from 'react';

interface BlockOuterContainerProps {
  id: string;
  title: string;
  children: React.ReactNode;
  blockLayout?: Layout;
  width: number;
}

export const BlockOuterContainer = forwardRef<HTMLDivElement, BlockOuterContainerProps>((props, ref) => {
  const { id, children, width } = props;

  return (
    <BlockIdContext.Provider value={id}>
      <BlockWidthContextProvider blockWidthPx={width}>
        <div ref={ref}>{children}</div>
      </BlockWidthContextProvider>
    </BlockIdContext.Provider>
  );
});
BlockOuterContainer.displayName = 'BlockOuterContainer';
